import constantes from '@/services/Constantes'

const urlApi = process.env.VUE_APP_URL_API
const pathLogin = '/api/login_check'
const pathPedidos = '/api/pedidos'
const pathPackFotos = '/api/pack_fotos'
const pathUsuarios = '/api/usuarios'
const pathRegister = '/api/auth/register'
const pathChangePassword = '/api/auth/change-password'
const pathConfirmUser = '/api/auth/confirm-user/'
const pathResetPassword = '/api/auth/reset-password/'
const pathRequestResetPassword = '/api/auth/request-reset-password'
const pathProcesarPedido = '/api/pedido/procesar'
const pathCadetes = '/api/cadetes'
const pathCategorias = '/api/categorias'
const pathAgrupamientos = '/api/agrupamientos'
const pathOferta = '/api/ofertas'

export default class ApiService {
  constructor (axios, vueJwtDecode) {
    this.axios = axios
    this.vueJwtDecode = vueJwtDecode
  }

  /**
   *
   * @param {*} usuario El usuario
   * @param {*} contrasena La contraseña
   * @param {*} decoderJWT El decodificador jwt
   * @param {*} funcionCallback La funcion que debe ejecutarse luego
   */
  login (usuario, contrasena, funcionCallback) {
    this.axios({
      method: 'post',
      url: urlApi + pathLogin,
      headers: {
        'Content-Type': 'application/json'
      },
      data: {
        username: usuario,
        password: contrasena
      }
    })
      .then(({
        data
      }) => {
        // Si no hubo error, devuelvo la informacion
        localStorage.jwt = data.token
        funcionCallback(false, data)
      })
      .catch(error => {
        // Si hubo error elimino los tokens almacenados
        localStorage.removeItem('jwt')
        funcionCallback(error)
      })
  }

  /**
   *
   * @param {*} callback La funcion que debe ejecutarse luego
   */
  logout (funcionCallback) {
    localStorage.removeItem('jwt')
    funcionCallback()
  }

  /**
   * Chequea si el token del usuario actual esta vencido, ademas si esta vencido lo borra
   *
   */
  isTokenExpired () {
    // Recupera el token
    const jwt = localStorage.getItem('jwt')
    // Decodifica el token
    const jwtDecoded = this.vueJwtDecode.decode(jwt)
    // Si el token expiró, borra el token almacenado y retorna falso
    if (Date.now() / 1000 > jwtDecoded.exp) {
      localStorage.removeItem('jwt')
      return true
    } // Si el token no expiró, retorna false
    return false
  }

  /**
   * Cheque si algun usuario se encuentra logueado, independientemente de si el token esta vencido
   */
  isAuthenticated () {
    // Recupera el token
    const jwt = localStorage.getItem('jwt')
    // Si existe retorna true
    if (jwt) {
      return true
    } else { // Sino retorna falso
      return false
    }
  }

  /**
   * Recupera todos los pedidos que se han realizado
   * @param {} itemsPerPage Items por pagina
   * @param {*} page Pagina
   * @param {*} filtrosActivados indica si se deben filtrar los resultados en backend
   * @param {*} funcionCallback
   */
  getPedidosAdmin (itemsPerPage, page, filtrosActivados, filtros, funcionCallback) {
    // Define los parametros
    let params = [`itemsPerPage=${itemsPerPage}`, `page=${page}`]

    // Activa los filtros si corresponden
    let filtrarEstados = true
    if (filtrosActivados) {
      for (let i = 0; i < filtros.length; i++) {
        if (filtros[i].nombre === 'estado') filtrarEstados = false
        params.push(`${filtros[i].nombre}=${filtros[i].valor}`)
      }
    }

    if (filtrarEstados) {
      const keysEstados = Object.keys(constantes.pedidos.estados)

      for (var i = 0; i < keysEstados.length; i++) {
        if (keysEstados[i] !== constantes.pedidos.estados.CARGANDO) {
          params.push(`estado[]=${keysEstados[i]}`)
        }
      }
    }

    params = params.join('&')

    // Obtiene el token
    var jwt = localStorage.getItem('jwt')

    // Realiza la llamada
    this.axios({
      method: 'get',
      url: urlApi + pathPedidos + '?' + params,
      headers: {
        Authorization: 'Bearer ' + jwt,
        accept: 'application/ld+json'
      }
    })
      .then(({
        data
      }) => {
        funcionCallback(false, data)
      })
      .catch(error => {
        funcionCallback(error)
      })
  }

  /**
   * Recupera todos los pedidos que ha realizado el usuario actual
   * @param {*} itemsPerPage Items por pagina
   * @param {*} page Pagina
   * @param {*} username Nombre de usuario
   * @param {*} funcionCallback
   */
  getPedidosUser (itemsPerPage, page, username, funcionCallback) {
    // Define los parametros
    let params = [`itemsPerPage=${itemsPerPage}`, `page=${page}`, `username=${username}`]
    const keysEstados = Object.keys(constantes.pedidos.estados)
    for (var i = 0; i < keysEstados.length; i++) {
      if (keysEstados[i] !== constantes.pedidos.estados.CARGANDO) {
        params.push(`estado[]=${keysEstados[i]}`)
      }
    }
    params = params.join('&')

    // Obtiene el token
    var jwt = localStorage.getItem('jwt')

    // Realiza la llamada
    this.axios({
      method: 'get',
      url: urlApi + pathPedidos + '?' + params,
      headers: {
        Authorization: 'Bearer ' + jwt,
        accept: 'application/ld+json'
      }
    })
      .then(({
        data
      }) => {
        funcionCallback(false, data)
      })
      .catch(error => {
        funcionCallback(error)
      })
  }

  /**
   * Recupera los datos de un usuario especifico
   * @param {*} username Nombre de usuario
   * @param {*} funcionCallback
   */
  getUsuarioById (id, funcionCallback) {
    // Obtiene el token
    var jwt = localStorage.getItem('jwt')

    // Realiza la llamada
    this.axios({
      method: 'get',
      url: urlApi + pathUsuarios + '/' + id,
      headers: {
        Authorization: 'Bearer ' + jwt,
        accept: 'application/ld+json'
      }
    })
      .then(({
        data
      }) => {
        funcionCallback(false, data)
      })
      .catch(error => {
        funcionCallback(error)
      })
  }

  /**
   * Registra un usuario nuevo en el backend
   *
   * @param {*} jsonData Datos asociados a usuario a ser registrado
   * @param {*} funcionCallback
   */
  registrarUsuario (jsonData, funcionCallback) {
    this.axios({
      method: 'post',
      url: urlApi + pathRegister,
      headers: {
        'Content-Type': 'application/json'
      },
      data: jsonData
    })
      .then(({
        data
      }) => {
        // Si no hubo error, devuelvo la informacion
        funcionCallback(false, data)
      })
      .catch(error => {
        // Si hubo error, pasa los mismos y llama al callback
        funcionCallback(error)
      })
  }

  /**
   * Cambia la contraseña para el usuario logueado
   * @param {*} jsonData
   * @param {*} funcionCallback
   */
  cambiarContrasena (jsonData, funcionCallback) {
    // Obtiene el token
    var jwt = localStorage.getItem('jwt')

    this.axios({
      method: 'post',
      url: urlApi + pathChangePassword,
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + jwt,
        accept: 'application/ld+json'
      },
      data: jsonData
    })
      .then(({
        data
      }) => {
        // Si no hubo error, devuelvo la informacion
        funcionCallback(false, data)
      })
      .catch(error => {
        // Si hubo error, pasa los mismos y llama al callback
        funcionCallback(error)
      })
  }

  /**
   * Confirma la registración de un usuario
   * @param {*} token El token generado para confirmación de usuario
   * @param {*} funcionCallback
   */
  confirmarUsuario (token, funcionCallback) {
    this.axios({
      method: 'post',
      url: urlApi + pathConfirmUser + token,
      headers: {
        accept: 'application/ld+json'
      }
    })
      .then(({
        data
      }) => {
        // Si no hubo error, devuelvo la informacion
        funcionCallback(false, data)
      })
      .catch(error => {
        // Si hubo error, pasa los mismos y llama al callback
        funcionCallback(error)
      })
  }

  /**
   * Resetea la contraseña de un usuario a partir de un token
   * @param {*} token
   * @param {*} jsonData
   * @param {*} funcionCallback
   */
  resetearContrasena (token, jsonData, funcionCallback) {
    this.axios({
      method: 'post',
      url: urlApi + pathResetPassword + token,
      headers: {
        'Content-Type': 'application/json',
        accept: 'application/ld+json'
      },
      data: jsonData
    })
      .then(({
        data
      }) => {
        // Si no hubo error, devuelvo la informacion
        funcionCallback(false, data)
      })
      .catch(error => {
        // Si hubo error, pasa los mismos y llama al callback
        funcionCallback(error)
      })
  }

  /**
   * Envia solicitud para resetear contraseña de un usuario especifico
   * @param {*} jsonData JSON con el username
   * @param {*} funcionCallback
   */
  solicitarResetearContrasena (jsonData, funcionCallback) {
    this.axios({
      method: 'post',
      url: urlApi + pathRequestResetPassword,
      headers: {
        'Content-Type': 'application/json',
        accept: 'application/ld+json'
      },
      data: jsonData
    })
      .then(({
        data
      }) => {
        // Si no hubo error, devuelvo la informacion
        funcionCallback(false, data)
      })
      .catch(error => {
        // Si hubo error, pasa los mismos y llama al callback
        funcionCallback(error)
      })
  }

  /**
   * Calcula si el token actual expira antes de las horas enviadas como parametro
   * @param {*} hs Las horas parametro para las cual se desea saber si el token actual expirara
   */
  tokenVenceEnMenosDeHs (hs) {
    // Recupera el token
    const jwt = localStorage.getItem('jwt')
    // Decodifica el token
    const jwtDecoded = this.vueJwtDecode.decode(jwt)
    // Calcula los segundos restantes al token
    const segundosRestantesToken = jwtDecoded.exp - (Date.now() / 1000)
    // Calcula si restan aun la cantidad de "hs" al token
    const horasASegundos = hs * 60 * 60
    if (segundosRestantesToken > horasASegundos) {
      return false
    } else {
      return true
    }
  }

  /**
   * Obtiene los diferentes tipos de pack de fotos disponibles y los precios
   * @param {*} funcionCallback
   */
  getPackFotos (funcionCallback) {
    // Define los parametros
    const params = [`habilitado=${true}`].join('&')

    // Obtiene el token
    var jwt = localStorage.getItem('jwt')

    // Realiza la llamada
    this.axios({
      method: 'get',
      url: urlApi + pathPackFotos + '?' + params,
      headers: {
        Authorization: 'Bearer ' + jwt,
        accept: 'application/ld+json'
      }
    })
      .then(({
        data
      }) => {
        funcionCallback(false, data)
      })
      .catch(error => {
        funcionCallback(error)
      })
  }

  /**
   * Procesa el pedido contra el backend
   * @param {*} id El id del pedido
   * @param {*} observaciones Observaciones del pedido
   * @param {*} cantidadFotos Cantidad de fotos totales
   */
  procesarPedido (id, observaciones, cantidadFotos, tipo, idPackFoto) {
    // Arma el json con la data
    const jsonData = {
      id,
      observaciones,
      cantidadFotos,
      tipo,
      idPackFoto
    }

    // Obtiene el token
    var jwt = localStorage.getItem('jwt')

    // Realiza la llamada
    const promise = this.axios({
      method: 'post',
      url: urlApi + pathProcesarPedido,
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + jwt,
        accept: 'application/ld+json'
      },
      data: jsonData
    })

    return promise
  }

  /**
   * Obtiene un pedido desde la api
   * @param {*} id
   */
  getPedido (id) {
    // Obtiene el token
    var jwt = localStorage.getItem('jwt')

    // Realiza la llamada
    const promise = this.axios({
      method: 'get',
      url: urlApi + pathPedidos + '/' + id,
      headers: {
        Authorization: 'Bearer ' + jwt,
        accept: 'application/ld+json'
      }
    })

    return promise
  }

  editPedido (pedido) {
    // Obtiene el token
    var jwt = localStorage.getItem('jwt')

    // Realiza la llamada
    const promise = this.axios({
      method: 'put',
      url: urlApi + pathPedidos + '/' + pedido.id,
      headers: {
        Authorization: 'Bearer ' + jwt,
        'Content-Type': 'application/ld+json',
        accept: 'application/ld+json'
      },
      data: pedido
    })

    return promise
  }

  /**
   * Obtiene el array de precios de cadete
   */
  getCadetes () {
    // Obtiene el token
    var jwt = localStorage.getItem('jwt')

    // Define los parametros
    const params = [`habilitado=${true}`].join('&')

    // Realiza la llamada
    const promise = this.axios({
      method: 'get',
      url: urlApi + pathCadetes + '?' + params,
      headers: {
        Authorization: 'Bearer ' + jwt,
        accept: 'application/ld+json'
      }
    })

    return promise
  }

  /**
   * Obtiene el array de categorias habilitadas
   */
  getCategorias () {
    // Define los parametros
    const params = [`habilitado=${true}`].join('&')

    // Realiza la llamada
    const promise = this.axios({
      method: 'get',
      url: urlApi + pathCategorias + '?' + params,
      headers: {
        accept: 'application/ld+json'
      }
    })

    return promise
  }

  /**
   * Obtiene el array de agrupamientos
   */
  getAgrupamientos () {
    // Define los parametros
    const params = [`pagination=${false}`].join('&')

    // Realiza la llamada
    const promise = this.axios({
      method: 'get',
      url: urlApi + pathAgrupamientos + '?' + params,
      headers: {
        accept: 'application/ld+json'
      }
    })

    return promise
  }

  /**
   * Obtiene el array de agrupamientos
   */
  getOfertasOrdenGral () {
    // Realiza la llamada
    const promise = this.axios({
      method: 'get',
      url: urlApi + pathOferta + '/orden_general?',
      headers: {
        accept: 'application/ld+json'
      }
    })

    return promise
  }

  /**
   * Obtiene el item oferta
   */
  getOferta (id) {
    // Obtiene el token
    var jwt = localStorage.getItem('jwt')

    // Realiza la llamada
    const promise = this.axios({
      method: 'get',
      url: urlApi + pathOferta + `/${id}`,
      headers: {
        accept: 'application/ld+json',
        Authorization: 'Bearer ' + jwt
      }
    })

    return promise
  }

  /**
   * Obtiene el item pack foto
   */
  getPackFoto (id) {
    // Obtiene el token
    var jwt = localStorage.getItem('jwt')

    // Realiza la llamada
    const promise = this.axios({
      method: 'get',
      url: urlApi + pathPackFotos + `/${id}`,
      headers: {
        accept: 'application/ld+json',
        Authorization: 'Bearer ' + jwt
      }
    })

    return promise
  }
}
